import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useFormState } from 'react-final-form';
import { updateFormState } from '../reducers/reactFinalFormReducer';

/**
 * Functional component FormStateToRedux
 * - Reads RFF form state via `useFormState`
 * - Dispatches a Redux action in an effect after each change to keep Redux in sync
 */
const FormStateToRedux = ({ form, updateFormState }) => {
  const state = useFormState();

  // After each render where `state` or `form` changes,
  // push the latest state into Redux store.
  useEffect(() => {
    updateFormState(form, state);
  }, [form, state, updateFormState]);

  // Nothing to render, this component only syncs state.
  return null;
};

FormStateToRedux.propTypes = {
  form: PropTypes.string.isRequired,
  updateFormState: PropTypes.func.isRequired,
};

// Connected functional component: only needs the action (no mapStateToProps)
export default connect(null, { updateFormState })(FormStateToRedux);
